import { Component, OnInit } from '@angular/core';
import { GetPackageConfiService } from './getPackageConfig.service';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-get-package-config',
  templateUrl: './get-package-config.component.html',
  styleUrls: ['./get-package-config.component.sass']
})
export class GetPackageConfigComponent implements OnInit {
  allAmounts:any;
  id:any
  helperAmount:any;
  couponAmount:any;
  tripFareGST:any;
  helperGST:any;
  commission:any;
  commissionGST:any;
  convenience:any;
  convenienceGST:any;
  distanceForTripNotification:any;
  helperTDSPercent:any;
  minimumDistanceForTrip:any;

  closeResult:string;
  constructor(
    private modalService: NgbModal,
    private getPackageConfiService:GetPackageConfiService,
    private spinner:NgxSpinnerService,
    private toastr:ToastrService
  ) { }

  ngOnInit(): void {
    this.getPkgConfig()
  }

  getPkgConfig(){
    this.getPackageConfiService.getPackageConfig().subscribe((result:any)=>{
      if(result.statusCode==200){
        console.log( "getPackageConfig",result)
        this.allAmounts=result.data
        this.id=this.allAmounts._id
        this.helperAmount=this.allAmounts.helpersBasicAmount
        this.couponAmount=this.allAmounts.couponBasicAmount
        this.tripFareGST=this.allAmounts.tripFareGST
        this.helperGST=this.allAmounts.helperGST
        this.commission=this.allAmounts.commissionFee
        this.commissionGST=this.allAmounts.commissionFeeGST
        this.convenience=this.allAmounts.convenienceFee
        this.convenienceGST=this.allAmounts.convenienceFeeGST
        this.distanceForTripNotification=this.allAmounts.distanceForNotification
        this.helperTDSPercent=this.allAmounts.helperTDS
        this.minimumDistanceForTrip=this.allAmounts.minimumDistanceForTrip
        console.log(this.id)
      }
    })
  }

  updatePackageConfig(){
    let data={
      "id": this.id,
      "helpersBasicAmount": this.helperAmount,
      "couponBasicAmount":this.couponAmount,
      "tripFareGST": this.tripFareGST,
      "helperGST":this.helperGST,
      "commissionFee":this.commission,
      "commissionFeeGST":this.commissionGST,
      "convenienceFee":this.convenience,
      "distanceForNotification":this.distanceForTripNotification,
      "convenienceFeeGST":this.convenienceGST,
      "minimumDistanceForTrip":this.minimumDistanceForTrip,
      "helperTDS":this.helperTDSPercent
  }
  console.log("reqData",data)
  this.spinner.show()
  this.getPackageConfiService.packageConfigUpdate(data).subscribe((result:any)=>{
    console.log("updatePackageConfigData", result)
    if(result.statusCode==200){
      this.spinner.hide();
      this.toastr.success(result.message);
      this.getPkgConfig();
      this.modalService.dismissAll();
    }else{
      this.spinner.hide();
      this.toastr.error(result.message);
    }
  })
  }
  editPackageConfig( editPkgConfig){
    this.openModal(editPkgConfig);
    this.helperAmount=this.helperAmount;
    this.couponAmount=this.couponAmount;
    this.tripFareGST=this.tripFareGST;
    this.helperGST=this.helperGST;
    this.commission=this.commission;
    this.commissionGST=this.commissionGST;
    this.convenience=this.convenience;
    this.convenienceGST=this.convenienceGST;
    this.distanceForTripNotification=this.distanceForTripNotification;
    this.helperTDSPercent=this.helperTDSPercent;
    this.minimumDistanceForTrip=this.minimumDistanceForTrip
}

  
  openModal(content) {
    this.modalService.open(content).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}
